import Header from './components/Header';
import Hero from './components/Hero';
import SectionFAQ from './components/SectionFAQ';
import SectionContact from './components/SectionContact';
import SectionMedia from './components/SectionMedia';
import SectionIndex from './components/SectionIndex';
import SectionCarousel from './components/SectionCarousel';
import SectionAbout from './components/SectionAbout';
import SectionUpdates from './components/SectionUpdates';
import SectionComments from './components/SectionComments';
import SectionCards from './components/SectionCards';
import SectionTopics from './components/SectionTopics';
import SectionApp from './components/SectionApp';
import SectionRanking from './components/SectionRanking';
import SectionFeatures from './components/SectionFeatures';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <SectionFAQ />

        <SectionContact />

        <SectionMedia />

        <SectionIndex />

        <SectionCarousel />

        <SectionAbout />

        <SectionUpdates />

        <SectionComments />

        <SectionCards />

        <SectionTopics />

        <SectionApp />

        <SectionRanking />

        <SectionFeatures />
      </main>

      <Footer />
    </div>
  );
}